import React from "react";
import { SITE } from "../lib/site";
import { Phone, Menu, X } from "lucide-react";

export default function Header() {
  const [open, setOpen] = React.useState(false);

  const links = [
    { href: "#chi-siamo", label: "Chi Siamo" },
    { href: "#servizi", label: "Servizi" },
    { href: "#visualizzatore", label: "Visualizzatore AI" },
    { href: "#progetti", label: "Progetti" },
    { href: "#contatti", label: "Contatti" },
  ];

  return (
    <header className="glass-header sticky top-0 z-40" data-testid="site-header">
      <div className="container-page flex items-center justify-between h-[72px]">
        <a href="#top" className="flex items-center gap-3" data-testid="logo-link">
          <img src={SITE.logo} alt="Edil Murgia" className="h-9 w-auto" />
          <span className="hidden sm:inline-block heading-display text-lg leading-none text-brand-ink">
            Edil <span className="text-brand-terracotta">Murgia</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-brand-ink/80 hover:text-brand-terracotta transition-colors"
              data-testid={`nav-${l.href.replace("#", "")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${SITE.phones[0].replace(/\s/g, "")}`}
            className="hidden md:inline-flex items-center gap-2 text-sm font-semibold text-brand-ink hover:text-brand-terracotta"
            data-testid="header-phone"
          >
            <Phone className="h-4 w-4" /> {SITE.phones[0]}
          </a>
          <a href="#contatti" className="btn-primary text-sm py-2.5 px-5" data-testid="cta-preventivo">
            Preventivo gratuito
          </a>
          <button
            className="lg:hidden p-2 rounded-md border border-brand-line"
            onClick={() => setOpen((v) => !v)}
            aria-label="menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-brand-line bg-white">
          <div className="container-page py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="py-2 text-base text-brand-ink"
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.href.replace("#", "")}`}
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
